import {
    Box,
    Button,
    Flex,
    Grid,
    GridItem,
    Icon,
    Input,
    Portal,
    Select,
    Text,
} from "@chakra-ui/react";
import { CalendarIcon, WhatsappLogoIcon } from "@phosphor-icons/react/dist/ssr";
import { useRouter } from "next/router";

import { timeOptionsCollection } from "@/utilities/helpers/timeOptions";

const FormDate = ({
    dataDevelopment,
    formatPrice,
    isGreaterThanLg,
    onOpen,
    setFormOrigin,
    date,
    setDate,
    time,
    setTime,
}) => {
    const router = useRouter();

    //Obtener el siguiente día para fijar el minimo en el input
    const getTomorrowDate = () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split("T")[0];
    };

    return isGreaterThanLg ? (
        <Box
            border="1px solid #E2E8F0"
            borderRadius="lg"
            p={4}
            boxShadow="sm"
            maxW="sm"
            mx="auto"
            bg="white"
        >
            <Text fontSize="lg" fontWeight="bold" textAlign="center">
                {`Desde ${formatPrice(dataDevelopment?.operation_props?.presale?.min_price !== "1" && dataDevelopment?.operation_props?.presale?.min_price !== 1 && dataDevelopment?.operation_props?.presale ? dataDevelopment?.operation_props?.presale?.min_price : dataDevelopment?.min_price || dataDevelopment?.operation_props?.sale?.min_price || dataDevelopment?.operation_props?.lease?.min_price)} MXN`}
            </Text>
            <Grid templateColumns={{ base: "repeat(1, 1fr)", xl: "repeat(2, 1fr)" }} gap={2} mt={4}>
                <GridItem border="1px solid #E2E8F0" borderRadius="md" p={1} textAlign="center">
                    <Text fontSize="sm" fontWeight="bold" color="black">
                        Día
                    </Text>
                    <Input
                        px={4}
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        min={getTomorrowDate()}
                        size="sm"
                        textAlign="center"
                        border="none"
                        color="gray.600"
                        _focus={{ outline: "none", borderBottom: "1px solid #CBD5E0" }}
                    />
                </GridItem>
                <GridItem border="1px solid #E2E8F0" borderRadius="md" p={1} textAlign="center">
                    <Text fontSize="sm" fontWeight="bold" color="black">
                        Hora
                    </Text>
                    <Select.Root
                        collection={timeOptionsCollection}
                        value={time ? [time] : []}
                        onValueChange={(details) => {
                            setTime(details.value[0]);
                        }}
                        size="sm"
                        style={{ textAlign: "center", border: "none" }}
                    >
                        <Select.HiddenSelect />
                        <Select.Control textAlign="center">
                            <Select.Trigger borderWidth={0} justifyContent="center">
                                <Select.ValueText
                                    placeholder="Hora"
                                    overflowWrap="break-word"
                                    whiteSpace="normal"
                                    color="gray.600"
                                />
                            </Select.Trigger>
                            <Select.IndicatorGroup pr={4}>
                                <Select.Indicator />
                            </Select.IndicatorGroup>
                        </Select.Control>
                        <Portal>
                            <Select.Positioner>
                                <Select.Content p={2}>
                                    {timeOptionsCollection.items.map((option) => (
                                        <Select.Item
                                            item={option}
                                            key={option.value}
                                            p={1}
                                            color="gray.600"
                                        >
                                            {option.label}
                                            <Select.ItemIndicator />
                                        </Select.Item>
                                    ))}
                                </Select.Content>
                            </Select.Positioner>
                        </Portal>
                    </Select.Root>
                </GridItem>
            </Grid>

            <Button
                mt={4}
                w="full"
                bg="#FECB2E"
                color="black"
                _hover={{ bg: "#E0A800" }}
                borderRadius="sm"
                onClick={(e) => {
                    e.preventDefault();
                    setFormOrigin("contact");
                    onOpen();
                }}
            >
                Agendar cita
            </Button>

            <Button
                mt={3}
                w="full"
                bg="green.500"
                color="white"
                _hover={{ bg: "green.600" }}
                borderRadius="sm"
                onClick={(e) => {
                    e.preventDefault();
                    setFormOrigin("whatsapp");
                    onOpen();
                }}
            >
                <Icon mr={2}>
                    <WhatsappLogoIcon />
                </Icon>
                Enviar Whatsapp
            </Button>

            {dataDevelopment?.boomerang_props?.selection_type && (
                <Button
                    mt={3}
                    bg="#FFFFFF"
                    w="100%"
                    textAlign="center"
                    borderWidth={1.5}
                    borderColor="#002B49"
                    borderRadius="sm"
                    _hover={{ background: "#F0F0F0" }}
                    fontWeight={400}
                    onClick={(e) => {
                        e.preventDefault();
                        router.push(
                            `${router.asPath}/seleccion?code=${dataDevelopment?.development_id}`
                        );
                    }}
                >
                    <Text color="accent.500">Consulta unidades disponibles</Text>
                </Button>
            )}
        </Box>
    ) : (
        <Flex
            boxShadow="sm"
            w="105%"
            py={6}
            gap={3}
            bg="white"
            justifyContent="center"
            position="fixed"
            bottom={0}
        >
            <Button
                border="2px solid #002B49"
                borderRadius="lg"
                color="#002B49"
                bg="white"
                fontSize="xs"
                fontWeight={400}
                maxW="55%"
                py={4}
                _hover={{ bg: "#E5F1FB" }}
                onClick={(e) => {
                    e.preventDefault();
                    router.push(
                        `${router.asPath}/seleccion?code=${dataDevelopment?.development_id}`
                    );
                }}
            >
                Consulta unidades disponibles
            </Button>

            <Button
                bg="#25D366"
                _hover={{ bg: "#1DA851" }}
                rounded="md"
                p={4}
                onClick={(e) => {
                    e.preventDefault();
                    setFormOrigin("whatsapp");
                    onOpen();
                }}
            >
                <Icon boxSize={6} color="white">
                    <WhatsappLogoIcon />
                </Icon>
            </Button>

            <Button
                bg="#FEC83D"
                _hover={{ bg: "#E6B731" }}
                rounded="md"
                p={4}
                onClick={(e) => {
                    e.preventDefault();
                    setFormOrigin("contact");
                    onOpen();
                }}
            >
                <Icon boxSize={6} color="black">
                    <CalendarIcon />
                </Icon>
            </Button>
        </Flex>
    );
};

export default FormDate;
